import { app } from '../../../../../app';
import { Controller } from './manage-user-details.controller';

app.component('companyUserDirectoriesManageUserDetails', {
    bindings: {
        account: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<',
        hardToken: '<',
        userSharedServiceAccounts: '<',
        devicesForCompanyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./manage-user-details.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/manage-user-details.component.js